import { render } from "./HeavyMachines.vue?vue&type=template&id=606387d6"
import script from "./HeavyMachines.vue?vue&type=script&lang=js"
export * from "./HeavyMachines.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__